/** @format */

import React from 'react';
import beautify from 'xml-beautifier';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';

export default function XmlView(xml, language) {
    if (!language) {
        language = 'xml';
    }
    xml = beautify(xml);
    return (
        <SyntaxHighlighter language={language} style={github} wrapLines={true}>
            {xml}
        </SyntaxHighlighter>
    );
}
